// extracted by mini-css-extract-plugin
export default {"modelDetailContactList":"c-f_em","modelDetailContactList__item":"c-f_en"};